import React from "react";
import { makeStyles } from '@material-ui/styles';

import HtmlContent from "../../../../../base/components/html_content.js";
import IcWhiteStar from "../../../../../resources/icons/ic_white_star.js";

const blockStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    padding: "0px 20px",
    ['@media (max-width: 768px)']: {
      padding: "0px",
    }

  },
  text: {
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.white,
    fontSize: "20px",
    marginBottom: "33px",
    display: "block",
    ['@media (max-width: 992px)']: {
      fontSize: "16px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
      lineHeight: "14px",
      marginBottom: "10px",
    },
  },
  starsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "30px",
    ['@media (max-width: 992px)']: {
      marginBottom: "15px",
    },
    ['@media (max-width: 768px)']: {
      marginBottom: "15px",
    },
  },
  star: {
    margin: "0px 6px",
    "&:first-child": {
      marginLeft: "0px"
    },
    "&:last-child": {
      marginRight: "0px"
    },
    ['@media (max-width: 992px)']: {
      width: "28px",
      height: "28px",
    },
    ['@media (max-width: 768px)']: {
      width: "18px",
      height: "18px",
      margin: "0px 3px",
    },
  },
  author: {
    fontSize: "18px",
    // color: theme.palette.greenMain,
    textTransform: "uppercase",
    display: "block",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "14px"
    },
  }
}));

const ReviewCard = (props) => {
  const classes = blockStyles();

  const { review } = props;

  return (
    <div className = { classes.root } >
      <HtmlContent className = { classes.text } >
        { review.text }
      </HtmlContent>
      <div>
        <div className = { classes.starsContainer } >
          {
            [...Array(parseInt(review.rating)).keys()].map((_, index) => {
              return <IcWhiteStar key = { index }
                                  className = { classes.star } />
            })
          }
        </div>
        <span className = { classes.author } >
          { review.author }
        </span>
      </div>
    </div>
  );
}

export default ReviewCard;
